<!-- Label Template -->
<ng-template #labelTemplate>
  @if (props.label) {
    <label [attr.for]="id"
           [class.form-label]="true"
           [class.input-inline-label]="labelPosition === 'inline'"
           [style.width]="labelPosition === 'inline' ? (props.labelWidth || '150px') : null">
      {{ props.label }}
      @if (required) {
        <span class="text-danger">*</span>
      }
    </label>
  }
</ng-template>

<!-- Select Field Template -->
<ng-template #selectFieldTemplate>
  <select [id]="id"
          [formControl]="formControl"
          [formlyAttributes]="field"
          class="form-select"
          [class.is-invalid]="showError">
    @if (placeholder) {
      <option [value]="null"
              disabled>{{ placeholder }}</option>
    }
    @for (option of selectOptions; track $index) {
      <option [value]="option.value">{{ option.label }}</option>
    }
  </select>

  @if (props.description) {
    <small class="form-text text-muted">{{ props.description }}</small>
  }

  @if (showError) {
    <div class="invalid-feedback d-block">
      <formly-validation-message [field]="field"></formly-validation-message>
    </div>
  }
</ng-template>

<!-- Main Layout -->
<div class="mb-3"
     [class.input-inline]="labelPosition === 'inline'">
  @if (labelPosition === 'inline') {
    <div class="input-inline-container">
      <ng-container *ngTemplateOutlet="labelTemplate"></ng-container>
      <div class="input-inline-field">
        <ng-container *ngTemplateOutlet="selectFieldTemplate"></ng-container>
      </div>
    </div>
  } @else {
    <ng-container *ngTemplateOutlet="labelTemplate"></ng-container>
    <ng-container *ngTemplateOutlet="selectFieldTemplate"></ng-container>
  }
</div>